import axios from 'axios'
import option from '../js/option'

// POST请求函数
export function POST (url, data, headers) {
  let headersParam = headers || {
    'Content-Type': 'application/json;charset=UTF-8'
  }
  return axios({
    method: 'post',
    headers: headersParam,
    url: `${option.requestUrl}${url}`,
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/request.js